import useAuth from 'src/hooks/useAuth';

import { Avatar, Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

function SidebarTopSection() {
  const { t } = useTranslation();
  const theme = useTheme();

  const { isAuthenticated, user } = useAuth();

  return (
    <Box
      sx={{
        textAlign: 'center',
        mx: 2,
        pt: 1,
        position: 'relative',
      }}
    >
      <Avatar
        sx={{
          width: 68,
          height: 68,
          mb: 2,
          mx: 'auto',
        }}
        alt={user?.name}
        src={user?.avatar}
      />

      <Typography
        variant="h4"
        sx={{
          color: `${theme.colors.alpha.trueWhite[100]}`,
        }}
      >
        {isAuthenticated ? user?.name : t('Guest')}
      </Typography>
      <Typography
        variant="subtitle1"
        sx={{
          color: `${theme.colors.alpha.trueWhite[70]}`,
        }}
      >
        {t(user?.jobtitle)}
      </Typography>
    </Box>
  );
}

export default SidebarTopSection;
